import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarToggler,
  MDBContainer,
  MDBIcon,
  MDBBtn,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem
} from 'mdb-react-ui-kit';
import Helper from '../../Helper';

const Appbar = forwardRef((props, ref) => {
  const canaccess = (role) => Helper.canaccess(role)

  return (
    <MDBNavbar expand='lg' light bgColor='white' fixed>
      <MDBContainer fluid>

        <MDBNavbarNav className='mb-2 mb-lg-0'>

          {canaccess("user") && <MDBNavbarItem>
            <MDBDropdown>
              <MDBDropdownToggle tag='a' className='nav-link' role='button'>
                งานขนส่ง
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link href='../Transport'>ลงข้อมูลงานขนส่ง</MDBDropdownItem>
                <MDBDropdownItem link href='../TransportList'>รายการงานขนส่ง</MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavbarItem>}
          {(canaccess("accountant") || canaccess("billing")) && <MDBNavbarItem>
            <MDBDropdown>
              <MDBDropdownToggle tag='a' className='nav-link' role='button'>
                งานบัญชี
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link href='../TransportAccountList'>รายการบัญชีขนส่ง</MDBDropdownItem>
                <li><hr class="dropdown-divider" /></li>
                <MDBDropdownItem link href='../TransportAccount_Bill'>สร้างใบวางบิล</MDBDropdownItem>
                <MDBDropdownItem link href='../TransportAccountList_Bill'>รายการใบวางบิล</MDBDropdownItem>
                <li><hr class="dropdown-divider" /></li>
                <MDBDropdownItem link href='../TransportAccount_Expense'>ลงข้อมูลบันทึกค่าใช้จ่าย</MDBDropdownItem>
                <MDBDropdownItem link href='../TransportAccountList_Expense'>รายการบันทึกค่าใช้จ่าย</MDBDropdownItem>


              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavbarItem>}
          {canaccess("billing") && <MDBNavbarItem>
            {/* <MDBNavbarLink aria-current='page' href='../TransportBillingList'>
              รายการการเงินขนส่ง
            </MDBNavbarLink> */}
            <MDBDropdown>
              <MDBDropdownToggle tag='a' className='nav-link' role='button'>
                งานการเงิน
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link href='../TransportBillingList'>รายการการเงินขนส่ง</MDBDropdownItem>
                <li><hr class="dropdown-divider" /></li>
                <MDBDropdownItem link href='../TransportAccountList_Bill'>รายการใบวางบิล</MDBDropdownItem>
                <li><hr class="dropdown-divider" /></li>
                <MDBDropdownItem link href='../TransportAccount_Receipt'>รวมใบเสร็จ</MDBDropdownItem>
                <MDBDropdownItem link href='../TransportAccountList_Receipt'>รายการรวมใบเสร็จ</MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavbarItem>}
          {canaccess("admin") && <MDBNavbarItem>
            <MDBDropdown>
              <MDBDropdownToggle tag='a' className='nav-link' role='button'>
                การจัดการ
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link href='../Dashboard'>ภาพรวม</MDBDropdownItem>
                <li><hr class="dropdown-divider" /></li>
                <MDBDropdownItem link href='../ManageUser'>จัดการข้อมูลผู้ใช้</MDBDropdownItem>
                <MDBDropdownItem link href='../ManageCompanyProfile'>จัดการข้อมูลบริษัท</MDBDropdownItem>
                <MDBDropdownItem link href='../ManageCustomerList'>จัดการข้อมูลลูกค้า</MDBDropdownItem>
                <MDBDropdownItem link href='../Managebillitem'>จัดการรายการบริการ</MDBDropdownItem>
                <MDBDropdownItem link href='../ManageMaster'>จัดการข้อมูลระบบ</MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBNavbarItem>}


        </MDBNavbarNav>
        <div className="d-flex align-items-center">
          <MDBBtn tag='a' color='link' href='../login'>
            Logout
          </MDBBtn>

        </div>
      </MDBContainer>
    </MDBNavbar>


  );
});

export default Appbar;